import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatchUpStatusEnum } from '../../_shared/models/csTypes/enums/matchup_status';
import { Observable, Subject } from 'rxjs';
import { Match } from '../../_shared/models/match.model';
@Injectable({ providedIn: 'root' })

export class TrackerBarService {
    private startLiveScoreObservable$ = new Subject<any>();

    constructor(private httpClient: HttpClient) { }

    addTracker(matchId, trackerIds: string[] = [], isInvited?: boolean, phone?: string, email?: string) {
        return this.httpClient.post<any>('api_endpoint' + '/match/add-tracker/', { matchId, trackerIds, isInvited, phone, email });
    }

    assignCourt(matchId, court) {
        return this.httpClient.post<any>('api_endpoint' + '/match/assign-court/', { matchId, court });
    }

    removeTracker(matchUpId: string, trackerId: string) {
        return this.httpClient.put<any>('api_endpoint' + '/match/remove-tracker/', { matchUpId, trackerId });
    }

    changeMatchStatus(matchUpId: string, matchUpStatus: MatchUpStatusEnum, endDate: Date) {
        return this.httpClient.put<any>('api_endpoint' + '/match/change-match-status/', { matchUpId, matchUpStatus, endDate });
    }

    // Transfer match
    transferMatch(transferObj) {
        return this.httpClient.put<any>('api_endpoint' + '/match/transfer/', transferObj);
    }

    submitScoreToPartner(matchId: string, tournamentId: string, partner: string) {
        return this.httpClient.post<any>('api_endpoint' + `/match/${matchId}/submitScoreToPartner`, { tournamentId, partner });
    }

    publishStartLiveScore(match: Match) {
        this.startLiveScoreObservable$.next(match);
    }

    subscribeStartLiveScore(): Observable<Match> {
        return this.startLiveScoreObservable$.asObservable();
    }
}
